import { render } from "./q5.vue?vue&type=template&id=408d4194&scoped=true"
import script from "./q5.vue?vue&type=script&lang=js"
export * from "./q5.vue?vue&type=script&lang=js"

import "./q5.vue?vue&type=style&index=0&id=408d4194&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408d4194"],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionTemplates/q5.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "408d4194"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('408d4194', __exports__)) {
    api.reload('408d4194', __exports__)
  }
  
  module.hot.accept("./q5.vue?vue&type=template&id=408d4194&scoped=true", () => {
    api.rerender('408d4194', render)
  })

}


export default __exports__